'use client'

import { useMemo } from 'react'

import { useClaimUserTodayCalendarReward } from '@/api/mutations/rewards'
import useRewards from '@/hooks/use-rewards'

import LockIcon from '@/components/icons/lock'
import Stepper from '@/components/reward/card/stepper'
import Button from '@/components/ui/button'
import { Countdown } from '@/components/ui/countdown'
import { Flex } from '@/styled-system/jsx'

export default function HeaderRewardsDropdownDailyItem() {
  const { userCalendarTodayRewardAmount, claimed } = useRewards()

  const { mutate: claim, isLoading: isClaiming } =
    useClaimUserTodayCalendarReward()

  const [availableRewardCount, nextClaimTime] = useMemo(() => {
    const startOfDay = new Date()
    startOfDay.setUTCHours(0, 0, 0, 0)

    const now = Date.now()

    const timeDiff = now - startOfDay.getTime()
    const nextStepIndex = Math.ceil(timeDiff / (1000 * 60 * 60 * 8))
    const availableRewardCount = nextStepIndex - claimed
    const nextClaimTime = new Date(
      startOfDay.getTime() + nextStepIndex * 8 * 60 * 60 * 1000
    )

    return [availableRewardCount, nextClaimTime]
  }, [claimed])

  const canClaim =
    userCalendarTodayRewardAmount >= 0.01 && availableRewardCount > 0

  const handleClaim = () => {
    claim()
  }

  return (
    <Flex
      align='center'
      justify='space-between'
      bg='neutral.50'
      borderWidth='1px'
      borderRadius='lg'
      px={3}
      py={4}
      w='full'
    >
      <Stepper activeIndex={claimed} isToday={true} />

      <Flex align='center' direction='column' gap={4}>
        {nextClaimTime ? <Countdown date={nextClaimTime} /> : null}

        <Button
          variant='primary'
          size='2xs'
          minW='7.25rem'
          disabled={!canClaim}
          loading={isClaiming}
          onClick={handleClaim}
          data-tag-id='Claim'
        >
          {canClaim ? (
            <>CLAIM ${userCalendarTodayRewardAmount.toFixed(2)}</>
          ) : (
            <>
              <LockIcon />
            </>
          )}
        </Button>
      </Flex>
    </Flex>
  )
}
